import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'xp-input',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './xp-input.component.html',
	styleUrls: ['./xp-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpInputComponent {
	type = input('text');
	placeholder = input('');
	readonly = input(false);
	min = input<number | null>(null);
	max = input<number | null>(null);
	prefixText = input('');
	suffixText = input('');
	value = model<string | number | null>(null);
}
